import { render, staticRenderFns } from "./AperGr.vue?vue&type=template&id=218f3fd7&scoped=true&"
import script from "./AperGr.vue?vue&type=script&lang=ts&"
export * from "./AperGr.vue?vue&type=script&lang=ts&"
import style0 from "./AperGr.vue?vue&type=style&index=0&id=218f3fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f3fd7",
  null
  
)

export default component.exports